import React from "react";
import { InputProps } from "@mui/material";
import TextField from "../TextField";
import Tooltip from "./Tooltip";

type InputFieldProps = {
  id: string;
  name: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  tooltipText?: string;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  multiline?: boolean;
  rows?: number;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  inputProps?: InputProps;
  maxLength?: number;
};

const InputField = ({
  id,
  name,
  label,
  value,
  onChange,
  tooltipText,
  placeholder,
  error = false,
  helperText = "",
  required = false,
  disabled = false,
  fullWidth = true,
  multiline = false,
  rows = 1,
  startAdornment,
  endAdornment,
  inputProps,
  maxLength,
}: InputFieldProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (maxLength && e.target.value.length > maxLength) {
      e.target.value = e.target.value.slice(0, maxLength);
    }
    onChange(e);
  };

  return (
    <div className="mb-6">
      <div className="flex items-center mb-1">
        <label htmlFor={id} className="block text-sm font-medium text-gray-900">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
        {tooltipText && <Tooltip content={tooltipText} />}
      </div>

      <TextField
        id={id}
        name={name}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        error={error}
        helperText={helperText}
        disabled={disabled}
        fullWidth={fullWidth}
        multiline={multiline}
        rows={rows}
        InputProps={{
          ...inputProps,
          startAdornment,
          endAdornment,
        }}
      />

      {maxLength && (
        <div className="flex justify-end mt-1">
          <span className="text-xs text-gray-500">
            {value.length}/{maxLength}
          </span>
        </div>
      )}
    </div>
  );
};

export default InputField;
